import { AppBarrageGameOverviewVO } from '@/client/app/Type/AppBarrageGameOverviewVO'
import { AppBaseInfoVO } from '@/client/app/Type/AppBaseInfoVO'
import { AppEaiOverviewVO } from '@/client/app/Type/AppEaiOverviewVO'
import { AppIMOverviewVO } from '@/client/app/Type/AppIMOverviewVO'
import { AppMeetingSolutionOverviewVO } from '@/client/app/Type/AppMeetingSolutionOverviewVO'
import { AppNetCallG2OverviewVO } from '@/client/app/Type/AppNetCallG2OverviewVO'
import { AppRcsFunctionOverviewVO } from '@/client/app/Type/AppRcsFunctionOverviewVO'
import { AppSmsOverviewVO } from '@/client/app/Type/AppSmsOverviewVO'
import { CloudCallFunctionOverViewVO } from '@/client/app/Type/CloudCallFunctionOverViewVO'
import { YiDunBillV2StatusVO } from '@/client/app/Type/YiDunBillV2StatusVO'
import { YiDunServiceInfoVO } from '@/client/app/Type/YiDunServiceInfoVO'
import { detail } from '@/client/app/apis/detail'
import { func5gmessagequery } from '@/client/app/apis/func5gmessagequery'
import { funcbarrageGameoverview } from '@/client/app/apis/funcbarrageGameoverview'
import { funccloudCalloverview } from '@/client/app/apis/funccloudCalloverview'
import { funceaioverview } from '@/client/app/apis/funceaioverview'
import { funcimoverview } from '@/client/app/apis/funcimoverview'
import { funcliveoverview } from '@/client/app/apis/funcliveoverview'
import { funcnetcallG2overview } from '@/client/app/apis/funcnetcallG2overview'
import { funcnetcalloverview } from '@/client/app/apis/funcnetcalloverview'
import { funcsmsoverview } from '@/client/app/apis/funcsmsoverview'
import { funcvodoverview } from '@/client/app/apis/funcvodoverview'
import { funcyiDunBillV2statusquery } from '@/client/app/apis/funcyiDunBillV2statusquery'
import { funcyiDunstatusquery } from '@/client/app/apis/funcyiDunstatusquery'
import { meetingSolutionoverview } from '@/client/app/apis/meetingSolutionoverview'
import { msgCopyconfigquery } from '@/client/app/apis/msgCopyconfigquery'
import { CorpRealNameAuthInfoVO } from '@/client/cust/Type/CorpRealNameAuthInfoVO'
import { CustInfoVO } from '@/client/cust/Type/CustInfoVO'
import { custInfoByCid } from '@/client/cust/apis/custInfoByCid'
import { realNameauthInfo } from '@/client/cust/apis/realNameauthInfo'
import { AppMusicCopyrightOverviewVO } from '@/client/musicCopyright/Type/AppMusicCopyrightOverviewVO'
import { appstatus } from '@/client/musicCopyright/apis/appstatus'
import { useState } from 'react'
import { useClosedConfirm } from '../Info/components/ClosedConfirm'
import { getTelOverview, getWhiteBoardOverview } from '../api'
interface IFetchInfo {
	aid: string
	cid: string
}
export default function Info() {
	const { showClosedConfirm, ClosedConfirmContext } = useClosedConfirm()
	/* 客户信息 */
	const [corpInfo, setCorpInfo] = useState<CustInfoVO>()
	const getCorpInfo = ({ cid }: { cid: string }) => {
		return custInfoByCid({ cid: cid }).then((res) => {
			setCorpInfo(res)
		})
	}
	/* 企业实名信息 */
	const [authInfo, setAuthInfo] = useState<CorpRealNameAuthInfoVO>()
	const getRealNameauthInfo = ({ cid }: { cid: string }) => {
		return realNameauthInfo({ cid }).then((res) => {
			setAuthInfo(res)
		})
	}
	/* 应用信息 */
	const [appInfo, setAppInfo] = useState<AppBaseInfoVO>()
	const updateAppInfo = (params: IFetchInfo) => {
		return detail({ aid: params.aid, cid: params.cid }).then((res) => {
			setAppInfo(res)
		})
	}
	/* 应用消息抄送信息 */
	const [msgCopy, setMsgCopy] = useState<string[]>([])
	const updateMsgCopy = (params: Omit<IFetchInfo, 'cid'>) => {
		return msgCopyconfigquery({ aid: params.aid }).then((res) => {
			setMsgCopy(res)
		})
	}

	/* im */
	const [imOverview, setImOverview] = useState<AppIMOverviewVO>()
	const updateImOverview = (params: IFetchInfo) => {
		funcimoverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setImOverview(res)
		})
	}
	/* 'IM', 'VOD', 'LIVE', 'NET_CALL_G2' 易盾服务版本，功能状态查询 */
	const [skuYidunStatus, setSkuYidunStatus] = useState<
		Partial<Record<'IM' | 'VOD' | 'LIVE' | 'NET_CALL_G2', YiDunServiceInfoVO>>
	>({})
	const updateSkuYidunStatus = (params: IFetchInfo & { productType: 'IM' | 'VOD' | 'LIVE' | 'NET_CALL_G2' }) => {
		funcyiDunstatusquery({ aid: params.aid, cid: params.cid, productType: params.productType }).then((res) => {
			setSkuYidunStatus((prevState) => ({ ...prevState, [params.productType]: res }))
		})
	}
	/* 直播 */
	const [liveOverview, setLiveOverview] = useState<Record<string, any>>()
	const updateLiveOverview = (params: IFetchInfo) => {
		funcliveoverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setLiveOverview(res)
		})
	}
	// /* 点播 */
	const [vodOverview, setVodOverview] = useState<Record<string, any>>()
	const updateVodOverview = (params: IFetchInfo) => {
		funcvodoverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setVodOverview(res)
		})
	}
	// /* 音视频2.0 */
	const [netcallOverview, setNetcallOverview] = useState<Record<string, any>>()
	const updateNetcallOverview = (params: IFetchInfo) => {
		funcnetcalloverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setNetcallOverview(res)
		})
	}
	/* 音视频2.0 */
	const [netcallG2Overview, setNetcallG2Overview] = useState<AppNetCallG2OverviewVO>()
	const updateNetcallG2Overview = (params: IFetchInfo) => {
		funcnetcallG2overview({ aid: params.aid, cid: params.cid }).then((res) => {
			setNetcallG2Overview(res)
		})
	}
	/* 短信 */
	const [smsOverview, setSmsOverview] = useState<AppSmsOverviewVO>()
	const updateSmsOverview = (params: IFetchInfo) => {
		funcsmsoverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setSmsOverview(res)
		})
	}
	/* 专线电话 */
	const [telOverview, setTelOverview] = useState<Record<string, any>>()
	const updateTelOverview = (params: IFetchInfo) => {
		getTelOverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setTelOverview(res)
		})
	}
	/* 互动白板 */
	const [whiteBoardOverview, setWhiteBoardOverview] = useState<Record<string, any>>()
	const updateWhiteBoardOverview = (params: any) => {
		getWhiteBoardOverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setWhiteBoardOverview(res)
		})
	}
	/* 弹幕游戏 */
	const [barrageGameOverview, setBarrageGameOverview] = useState<AppBarrageGameOverviewVO>()
	const updateBarrageGameOverview = (params: IFetchInfo) => {
		funcbarrageGameoverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setBarrageGameOverview(res)
		})
	}
	/* 5g消息 */
	const [message5gOverview, setMessage5gOverview] = useState<AppRcsFunctionOverviewVO>()
	const updateMessage5gOverview = (params: IFetchInfo) => {
		func5gmessagequery({ aid: params.aid, cid: params.cid }).then((res) => {
			setMessage5gOverview(res)
		})
	}
	/* 云呼叫中心 */
	const [cloudCalloverview, setCloudCalloverview] = useState<CloudCallFunctionOverViewVO>()
	const updateCloudCalloverview = (params: IFetchInfo) => {
		funccloudCalloverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setCloudCalloverview(res)
		})
	}
	/* 会议状态 */
	const [meetingOverview, setMeetingOverview] = useState<AppMeetingSolutionOverviewVO>()
	const updateMeetingOverview = (params: IFetchInfo) => {
		return meetingSolutionoverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setMeetingOverview(res)
		})
	}
	/* AI 硬件智能体状态 */
	const [eaiOverview, setEaiOverview] = useState<AppEaiOverviewVO>()
	const updateEaiOverview = (params: IFetchInfo) => {
		return funceaioverview({ aid: params.aid, cid: params.cid }).then((res) => {
			setEaiOverview(res)
		})
	}
	/* 音乐版权 */
	const [musicOverview, setMusicOverview] = useState<AppMusicCopyrightOverviewVO>()
	const updateMusicOverview = (params: IFetchInfo) => {
		appstatus({ aid: params.aid, cid: params.cid }).then((res) => {
			setMusicOverview(res)
		})
	}
	/* 安全通V2*/
	const [yidunV2Status, setYidunV2Status] = useState<YiDunBillV2StatusVO>()
	const updateYidunV2Status = (params: IFetchInfo) => {
		funcyiDunBillV2statusquery({ aid: params.aid, cid: params.cid }).then((res) => {
			setYidunV2Status(res)
		})
	}
	return {
		corpInfo,
		getCorpInfo,
		authInfo,
		getRealNameauthInfo,
		appInfo,
		updateAppInfo,
		msgCopy,
		updateMsgCopy,
		skuYidunStatus,
		updateSkuYidunStatus,
		imOverview,
		updateImOverview,
		vodOverview,
		updateVodOverview,
		liveOverview,
		updateLiveOverview,
		netcallOverview,
		updateNetcallOverview,
		netcallG2Overview,
		updateNetcallG2Overview,
		smsOverview,
		updateSmsOverview,
		telOverview,
		updateTelOverview,
		whiteBoardOverview,
		updateWhiteBoardOverview,
		barrageGameOverview,
		updateBarrageGameOverview,
		message5gOverview,
		updateMessage5gOverview,
		cloudCalloverview,
		updateCloudCalloverview,

		meetingOverview,
		updateMeetingOverview,
		eaiOverview,
		updateEaiOverview,
		musicOverview,
		updateMusicOverview,
		yidunV2Status,
		updateYidunV2Status,
		showClosedConfirm,
		ClosedConfirmContext,
	}
}
